import {createContext, useState} from 'react'

const CartContext = createContext({});
export const UseCartContext = ({children}) => {
    const [cartCount , setCartCount]  = useState();
    return (
        <CartContext.Provider value={{cartCount , setCartCount}}>{children}</CartContext.Provider>
    )
}
export default CartContext;